import { mdiFileDownload, mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Drawer, Menu, notification } from "antd";
import React, { useState } from "react";
import type { MenuProps } from 'antd';
import { Link, useLocation, useMatch } from "react-router-dom";
import BrochueApi from "../../api-services/brochure-api.service";

type MenuItem = Required<MenuProps>['items'][number];


function withLocation(Component) {
  return props => <Component {...props} location={useLocation()} />;
}

class Header extends React.Component <{location}> {
  brochureApi = new BrochueApi;



  items: MenuItem[] = [
    {
      key: 'web',
      label: <Link to="/web"> Home </Link>
    },
    {
      key: 'about-us',
      label: <Link to="/web/about-us"> About Us </Link>
    },
    {
      key: 'countries',
      label: <Link to="/web/countries"> Countries </Link>
    },
    {
      key: 'blog',
      label: <Link to="/web/blog"> Blog </Link>
    },
    {
      key: 'logo',
      label: <img src="/iceholidays-assets/images/logo.png" className="logo logo_desktop"/>,
      disabled: true
    },
    {
      key: 'contact-agents',
      label: <Link to="/web/contact-agents"> Contact Agents </Link>
    },
    {
      key: 'contact-us',
      label: <Link to="/web/contact-us"> Contact Us </Link>
    },
    {
      key: 'brochure',
      label: <Button onClick={()=>this.downloadBrochure()} className="get-brochure" id="get-brochure-menu" type="primary"><Icon path={mdiFileDownload} size="18px" /> get brochure</Button>,
      disabled: true
    },
  ]

  state = {
    open: false,
    current: "",
  }

  constructor(props:any){
    super(props);
  }


  componentDidMount() {
    this.setLocation();
  }


  downloadBrochure() {
    this.brochureApi.getBrochure()
      .then((brochureUrl:any) => {
        // const blob = brochureUrl.blob();
        // const blobURL = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = brochureUrl;
        a.setAttribute('style', "display: none");

        a.download = "Brochure";
        document.body.appendChild(a);
        a.click();
      })
      .catch(error => {
        notification.error({ message: 'An error occured while getting brochure.'});
      });

  }


  private setLocation(){
    const location = this.props.location
    const activeUrlKey = location.pathname.split("/").pop() || "web";
    this.setState({current: activeUrlKey});
  }


  onClick: MenuProps['onClick'] = (e) => {
    this.setState({open: false, current: e.key})
  };

  showDrawer() {
    this.setState({open: true});
  };

  onClose() {
    this.setState({open: false});
  };

  render(){
    const {open, current } = this.state;
    return (
      <div className="header">
        <Menu mode="horizontal" items={this.items} onClick={this.onClick} selectedKeys={[current]} className="nav-menu"/>
  
        <a href="/web"><img src="/iceholidays-assets/images/logo_mobile.png" className="logo logo_mobile"/></a>
  
        <div id="nav-buttons">
          <Button onClick={()=>this.downloadBrochure()} className="get-brochure" id="get-brochure-mobile" type="primary"><Icon path={mdiFileDownload} size="18px" /> get brochure</Button>
  
          <Button id="toggle-menu" type="primary" onClick={()=>this.showDrawer()}>
            <Icon path={mdiMenu} size="25px" />
          </Button>
        </div>
  
        <Drawer title={null} onClose={()=>this.onClose()} open={open} id="nav-drawer">
          <Menu items={this.items} onClick={this.onClick} selectedKeys={[current]} className="nav-menu_mobile"/>
        </Drawer>
      </div>
    )
  }
  
}

export default withLocation(Header);